import type { BookingLite } from '../types/shared'
import type {
  Golf,
  PassCarnet,
  PatchUpdatePasswordDTO,
  PatchUsersDTO,
  PostUsersDTO,
  Product,
  User,
} from '../types/users'

export const useUsersService = () => {
  const config = useRuntimeConfig()
  const BASE_URL = `${config.public.apiBase}/api/users`

  return {
    postUser(p: PostUsersDTO) {
      return fetchJson<FetchResult<User>, typeof p>(
        'POST', `${BASE_URL}`, p,
      )
    },
    verifyUser(userId: number, signature: string, expires: number) {
      return fetchJson(
        'POST', `${BASE_URL}/${userId}/verify?signature=${signature}&expires=${expires}`,
      )
    },
    getUser() {
      return fetchJson<FetchResult<User>>(
        'GET', `${BASE_URL}/me`,
      )
    },
    patchUser(p: PatchUsersDTO) {
      return fetchJson<FetchResult<User>, typeof p>(
        'PATCH', `${BASE_URL}/me`, p,
      )
    },
    deleteUser() {
      return fetchJson(
        'DELETE', `${BASE_URL}/me`,
      )
    },
    getBookings() {
      return fetchJson<FetchResult<(BookingLite | Product)[]>>(
        'GET', `${BASE_URL}/me/bookings`,
      )
    },
    getFavorites() {
      return fetchJson<FetchResult<Golf[]>>(
        'GET', `${BASE_URL}/me/favourites`,
      )
    },
    postFavorite(id: number) {
      return fetchJson<FetchResult<Golf>>(
        'POST', `${BASE_URL}/me/favourites/${id}`,
      )
    },
    deleteFavorite(id: number) {
      return fetchJson(
        'DELETE', `${BASE_URL}/me/favourites/${id}`,
      )
    },
    getPassCarnets() {
      return fetchJson<FetchResult<PassCarnet[]>>(
        'GET', `${BASE_URL}/me/pass-carnets`,
      )
    },
    patchUpdatePassword(p: PatchUpdatePasswordDTO) {
      return fetchJson<FetchResult<User>, typeof p>(
        'PATCH', `${BASE_URL}/me/update-password`, p,
      )
    },
  }
}
